import { ProductLabelProperty } from 'components/atoms/ProductLabel';
import { NewsType } from '.';

type NewsLabelConfig = Pick<ProductLabelProperty, 'text' | 'backgroundColor' | 'textColor'>;

export const NewsLabelMapping: Record<NewsType, NewsLabelConfig> = {
	最新公告: {
		text: '最新公告',
		backgroundColor: '#FCDFE6',
		textColor: '#F27292',
	},
	會員活動: {
		text: '會員活動',
		backgroundColor: '#E3F7FD',
		textColor: '#17B9EC',
	},
	媒體報導: {
		text: '媒體報導',
		backgroundColor: '#E6E3F1',
		textColor: '#8C7DBE',
	},
	私密基地: {
		text: '私密基地',
		backgroundColor: '#D7EDD0',
		textColor: '#70BF54',
	},
	性平之路: {
		text: '性平之路',
		backgroundColor: '#FFF0B9',
		textColor: '#FF9900',
	},
};
